<div class="overlay-container">
</div>
<div class="modal show" id="myModal" style="top: 10%; ">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">

        <div id="addorUpdat" class="mt-4 mb-4">Enroll with <img 
          src="{{globalService.staticResourceURL}}assets/images/Icon-logo-white-small-color.svg" class="img-fluid logo-second"/></div> 
        <div class="row no-margin">
          <div class="col-12 col-sm-12 mb-3" [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.enrollmentText">
            <!-- If you’re a registered MyEasyGov user, log in now and you’ll be able to update your profile with the renewal
            information.
            <br /><br>
            If you’re not a registered MyEasyGov user, please take a minute to register. Once registered, you’ll be able
            to manage and simplify future renewals. -->
          </div>




          <div class="col-12 col-sm-12 mb-3 mt-4">
            <a>
              <button class="btn btn-primary btn-commonbtn m-auto addressChangeBtn" (click)="noThanksAction()">No thanks<br/>
              Continue as Guest</button>
            </a>
          </div>
          <div class="col-12 col-sm-12 mb-3">
            <a>
              <button class="btn btn-primary btn-commonbtn m-auto addressChangeBtn" (click)="logInAction()">Log In
              </button>
            </a>
          </div>
          <div class="col-12 col-sm-12 mb-4">
            <a>
              <button class="btn btn-primary btn-commonbtn m-auto addressChangeBtn" (click)="registerAction()">Enroll
              </button>
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>